var _style, _path, _path2, _path3, _path4, _path5, _path6, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecognition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 190 102.2",
    style: {
      enableBackground: "new 0 0 190 102.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:#E80054;}\n\t.st7{fill:#FFDD40;}\n\t.st8{fill:#FFB332;}\n\t.st9{fill:#FF9100;}\n\t.st10{fill:#FFE98D;}\n\t.st11{fill:#A05838;}\n\t.st12{fill:#823C26;}\n\t.st13{fill:#E9EFFF;}\n\t.st14{fill:#D3DCFB;}\n\t.st15{fill:#BEC8F7;}\n\t.st16{fill:#FF4155;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.6959,
    y1: 58.7863,
    x2: 172.7519,
    y2: 66.3203,
    gradientTransform: "matrix(1 0 0 -1 0 105.5548)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#400300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0709114,
    style: {
      stopColor: "#750300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1439,
    style: {
      stopColor: "#A50300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2084,
    style: {
      stopColor: "#C80300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2612,
    style: {
      stopColor: "#DD0300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2957,
    style: {
      stopColor: "#E50300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3376,
    style: {
      stopColor: "#EE190C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3927,
    style: {
      stopColor: "#F82E18"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4459,
    style: {
      stopColor: "#FD3C20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4946,
    style: {
      stopColor: "#FF4022"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5442,
    style: {
      stopColor: "#FD3B1F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5995,
    style: {
      stopColor: "#F72E18"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6574,
    style: {
      stopColor: "#EE180C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6989,
    style: {
      stopColor: "#E50300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7336,
    style: {
      stopColor: "#DB0300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7914,
    style: {
      stopColor: "#C20300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8653,
    style: {
      stopColor: "#980300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9515,
    style: {
      stopColor: "#5E0300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B0300"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.6,45.6c0.7-2,0.6-3.4-0.7-5.2c-2.3-0.3-3.9-0.2-5.4,0.6c-0.1,2.3-1,3.8-2.5,6.2 C172.1,46.2,174.1,45.6,177.6,45.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.2763,
    y1: 97.56,
    x2: 184.5713,
    y2: 100.0101,
    gradientTransform: "matrix(1 0 0 -1 0 105.5548)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0038AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1131,
    style: {
      stopColor: "#0062C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    style: {
      stopColor: "#0097F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3495,
    style: {
      stopColor: "#00ACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4014,
    style: {
      stopColor: "#00BFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#00D2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5161,
    style: {
      stopColor: "#00D9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6633,
    style: {
      stopColor: "#00B8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    style: {
      stopColor: "#00ACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    style: {
      stopColor: "#00A2F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    style: {
      stopColor: "#0086E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9337,
    style: {
      stopColor: "#0059C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0038AB"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184,9.3c1.2,0.3,2.2,0.9,3.4,1.9c0.8-3,1.4-4.9,2.6-6.9c-1-1.3-1.8-1.7-3.1-2.1C186,3.6,184.9,6.2,184,9.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.4666,
    y1: 75.2886,
    x2: 6.4756,
    y2: 82.6443,
    gradientTransform: "matrix(1 0 0 -1 0 105.5548)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#920040"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0478432,
    style: {
      stopColor: "#AE0052"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    style: {
      stopColor: "#D10069"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1861,
    style: {
      stopColor: "#EA007A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    style: {
      stopColor: "#FA0084"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2957,
    style: {
      stopColor: "#FF0087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3487,
    style: {
      stopColor: "#FF1A8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4347,
    style: {
      stopColor: "#FF3F92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5043,
    style: {
      stopColor: "#FF5696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FF5E97"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5841,
    style: {
      stopColor: "#FF5696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    style: {
      stopColor: "#FF3F92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7115,
    style: {
      stopColor: "#FF198B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7527,
    style: {
      stopColor: "#FF0087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7936,
    style: {
      stopColor: "#FA0084"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8443,
    style: {
      stopColor: "#EA007A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9001,
    style: {
      stopColor: "#D10069"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9592,
    style: {
      stopColor: "#AE0053"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#920040"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.5,24.4c-0.1-1.6-0.9-2.6-2.2-4.2C9.9,23.3,5.4,25.6,0,27.7C1,29,1.3,30.1,1.5,32 C7.3,30,10.5,28.4,15.5,24.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.3679,
    y1: 38.3947,
    x2: 39.3614,
    y2: 33.2339,
    gradientTransform: "matrix(1 0 0 -1 0 105.5548)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#005200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1859,
    style: {
      stopColor: "#00890B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    style: {
      stopColor: "#00A912"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3267,
    style: {
      stopColor: "#11AD12"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3667,
    style: {
      stopColor: "#3AB512"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    style: {
      stopColor: "#5ABC12"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    style: {
      stopColor: "#71C112"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4795,
    style: {
      stopColor: "#7EC412"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    style: {
      stopColor: "#83C512"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#7FC412"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5906,
    style: {
      stopColor: "#72C112"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    style: {
      stopColor: "#5EBD12"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6737,
    style: {
      stopColor: "#41B712"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7154,
    style: {
      stopColor: "#1CAF12"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7419,
    style: {
      stopColor: "#00A912"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783,
    style: {
      stopColor: "#009E10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8555,
    style: {
      stopColor: "#00800C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9504,
    style: {
      stopColor: "#005004"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003400"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30,70.5c1.6,2.3,2.9,3.4,5.8,4.6c1.1-3.3,2.3-5.1,4.2-6.6c-1.3-2.3-2.6-3.6-4.8-5.3C33.9,66.2,32.5,68,30,70.5 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.6763,
    y1: 17.4752,
    x2: 170.2513,
    y2: 9.7425,
    gradientTransform: "matrix(1 0 0 -1 0 105.5548)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB3C00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3441,
    style: {
      stopColor: "#FFC700"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3696,
    style: {
      stopColor: "#FFCD17"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4069,
    style: {
      stopColor: "#FFD533"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4445,
    style: {
      stopColor: "#FFDA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4826,
    style: {
      stopColor: "#FFDD52"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5215,
    style: {
      stopColor: "#FFDE56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    style: {
      stopColor: "#FFDD51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5855,
    style: {
      stopColor: "#FFD943"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6225,
    style: {
      stopColor: "#FFD32B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    style: {
      stopColor: "#FFCA0B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    style: {
      stopColor: "#FFC700"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB3C00"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M168.4,88.2c-0.2,2.3-0.9,3.5-2.4,5.2c3.6,1,7.4,1.5,9.1,1.2c0.5-1.7,0.6-3.3,0.3-5.5 C173.6,89.5,171.7,89.1,168.4,88.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.4341,
    y1: 7.1118,
    x2: 48.734,
    y2: 5.7321,
    gradientTransform: "matrix(1 0 0 -1 0 105.5548)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0038AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1131,
    style: {
      stopColor: "#0062C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    style: {
      stopColor: "#0097F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3495,
    style: {
      stopColor: "#00ACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4014,
    style: {
      stopColor: "#00BFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#00D2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5161,
    style: {
      stopColor: "#00D9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6633,
    style: {
      stopColor: "#00B8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    style: {
      stopColor: "#00ACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    style: {
      stopColor: "#00A2F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    style: {
      stopColor: "#0086E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9337,
    style: {
      stopColor: "#0059C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0038AB"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M53,101.3c-0.2-2-0.6-3.7-1.7-5.1c-1.5,0.1-2.4,0.4-3.3,1c1.2,1.8,1.5,2.9,1.6,5C50.8,101.4,51.7,101,53,101.3z "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M107.7,6.4c-26.5,0-48,21.5-48,48c0,20.4,12.7,37.8,30.7,44.8H125c17.9-6.9,30.7-24.4,30.7-44.8 C155.7,27.9,134.2,6.4,107.7,6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M114,70c-1.3-1.3-3.3-3.7-3.5-6.9c-0.8,0.4-1.8,0.7-2.8,0.7c-0.1,0-0.3,0-0.4,0v20.5c0.1,0,0.3,0,0.4,0 c2.1,0,4.1,0.4,6,1.2l1.4-12.8C115.1,71.8,114.8,70.7,114,70z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M113.6,85.6l1.4-12.8c0,0,0,0,0,0c0,0,0,0,0,0c-2.1,3.6-4.9,2.9-6.3,2.2c-0.4-0.2-0.9-0.3-1.4-0.2v9.6 c0.1,0,0.3,0,0.4,0C109.8,84.3,111.8,84.8,113.6,85.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M104.9,63.2c-0.2,3.2-2.2,5.6-3.5,6.9c-0.7,0.7-1.1,1.7-1,2.8l1.4,12.8c1.8-0.8,3.8-1.2,6-1.2l0-20.5 C106.7,63.8,105.7,63.6,104.9,63.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M107.7,84.3l0-9.6c-0.3,0-0.7,0.1-1,0.2c-3.9,1.8-6.3-2.2-6.3-2.2l1.4,12.8C103.5,84.8,105.6,84.3,107.7,84.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M102.2,55.3c-0.4,0.8-0.7,1.8-0.7,2.8c0,3.4,2.8,6.2,6.2,6.2c3.4,0,6.2-2.8,6.2-6.2c0-1-0.2-2-0.7-2.8 C109.8,57.3,105.5,57.3,102.2,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M119.7,90c-2.7-3.7-7.1-6.1-12-6.1c-4.9,0-9.3,2.4-12,6.1H119.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M110.8,84.2c-1-0.2-2.1-0.3-3.2-0.3c-4.9,0-9.3,2.4-12,6.1h14.6C108.4,88.5,108.6,85.3,110.8,84.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M83.5,9.3C83.5,9.3,83.5,9.3,83.5,9.3c0,9.4,1.9,30.9,16.8,45c4.1,3.9,10.7,3.9,14.8,0 c14.8-14.1,16.7-35.6,16.8-45H83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M97.8,24.5c-0.7-5.5,3.5-10.5,9.1-10.5l24.8,0c0.1-1.8,0.2-3.4,0.2-4.8H83.5c0,0,0,0,0,0 c0.1,9.4,1.9,30.9,16.8,45c3,2.9,7.4,3.6,11.1,2.3C102.6,46.8,99.1,34.2,97.8,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M131.8,9.7H83.5c-1.6,0-2.9-1.3-2.9-2.9s1.3-2.9,2.9-2.9h48.3c1.6,0,2.9,1.3,2.9,2.9 C134.7,8.4,133.4,9.7,131.8,9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M97.6,6.8c0-1.6,1.3-2.9,2.9-2.9H83.5c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9h16.9 C98.9,9.7,97.6,8.4,97.6,6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M93.5,58.4c-1-0.6-1.3-2-0.7-3c1.3-2-0.2-4.9-2.8-4.9c0,0-0.1,0-0.1,0l-0.1,0c-2,0.1-4.1-0.7-5.5-2.2 c-16-15.8-20.7-30.6-22.1-38c-0.8-4.2,2.4-8.2,6.7-8.3C72.3,2,75.4,4.5,76,7.9l0,0.2c0.4,2.2,2.4,3.8,4.6,3.7l2.5-0.1 c1.2,0,2.2,0.9,2.2,2.1c0,1.2-0.9,2.2-2.1,2.2l-2.5,0.1c-4.3,0.1-8.2-3-8.9-7.2l0-0.2c-0.2-1.3-1.4-2.3-2.7-2.3 c-1.7,0-2.9,1.6-2.6,3.2c1.3,6.9,5.7,20.7,20.9,35.7c0.6,0.6,1.5,1,2.4,0.9l0.1,0c6.2-0.2,9.8,6.6,6.7,11.5 C95.8,58.7,94.5,59,93.5,58.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M122.9,89.5H92.4c-1.4,0-2.6,1.2-2.6,2.6v6.8c1.4,0.6,2.8,1,4.2,1.5h27.2c1.4-0.4,2.8-0.9,4.2-1.5v-6.8 C125.5,90.7,124.3,89.5,122.9,89.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M89.9,92.1v6.8c1.4,0.6,2.8,1,4.2,1.5h13.2v-1.3c0-1,0.6-1.7,1.2-2.2c0.3-0.3,0.4-0.7,0.2-1.1 c-0.5-0.9-0.1-1.7,0.3-2.2c0.2-0.3,0.2-0.6,0.1-0.9c-0.6-1.3-0.1-2.1,0.4-2.6c0.2-0.2,0.3-0.4,0.3-0.6H92.4 C91,89.5,89.9,90.7,89.9,92.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M118.4,94.9H97c-0.9,0-1.5,0.7-1.5,1.5v4.3c3.9,1,8,1.6,12.2,1.6c4.2,0,8.3-0.5,12.2-1.6v-4.3 C119.9,95.6,119.2,94.9,118.4,94.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M108.5,97c0.3-0.3,0.4-0.7,0.2-1.1c-0.2-0.3-0.2-0.7-0.2-1H97c-0.9,0-1.5,0.7-1.5,1.5v4.3 c3.8,1,7.7,1.5,11.8,1.6v-3.2C107.3,98.1,107.9,97.4,108.5,97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M118.4,93.3H97c-1.7,0-3.2,1.4-3.2,3.2v3.9c1.1,0.3,2.1,0.6,3.2,0.8v-4.7h21.3v4.7c1.1-0.2,2.2-0.5,3.2-0.8 v-3.9C121.5,94.7,120.1,93.3,118.4,93.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M108.7,95.9c-0.5-0.9-0.1-1.7,0.3-2.2c0.1-0.1,0.1-0.3,0.2-0.4H97c-1.7,0-3.2,1.4-3.2,3.2v3.9 c1.1,0.3,2.1,0.6,3.2,0.8v-4.7h11.7C108.8,96.3,108.8,96.1,108.7,95.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M109,62.4c1.2,0,2.1-1,2.1-2.1c0-1.2-1-2.1-2.1-2.1s-2.1,1-2.1,2.1C106.9,61.4,107.8,62.4,109,62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M111.7,28c1.2,0,2.1-1,2.1-2.1s-1-2.1-2.1-2.1s-2.1,1-2.1,2.1S110.5,28,111.7,28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M118.9,25.2c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8c-2.1,0-3.8,1.7-3.8,3.8 C115,23.5,116.7,25.2,118.9,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M68.2,5.6c0,0.3-0.1,0.7-0.2,1c0.3-0.1,0.6-0.2,1-0.2c1.3,0,2.5,0.9,2.7,2.3l0,0.2c0.8,4.2,4.6,7.4,8.9,7.2 l2.5-0.1c1.2,0,2.1-1,2.1-2.2c0-1.2-1-2.1-2.2-2.1l-2.5,0.1c-2.2,0.1-4.2-1.5-4.6-3.7l0-0.2c-0.6-3.4-3.6-5.9-7.1-5.8 c-1.1,0-2.2,0.3-3.1,0.8C67.1,3,68.2,4.2,68.2,5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M121.9,58.4c1-0.6,1.3-2,0.7-3c-1.3-2,0.2-4.9,2.8-4.9c0,0,0.1,0,0.1,0l0.1,0c2,0.1,4.1-0.7,5.5-2.2 c16-15.8,20.7-30.6,22.1-38c0.8-4.2-2.4-8.2-6.7-8.3C143,2,140,4.5,139.4,7.9l0,0.2c-0.4,2.2-2.4,3.8-4.6,3.7l-2.5-0.1 c-1.2,0-2.2,0.9-2.2,2.1c0,1.2,0.9,2.2,2.1,2.2l2.5,0.1c4.3,0.1,8.2-3,8.9-7.2l0-0.2c0.2-1.3,1.4-2.3,2.7-2.3 c1.7,0,2.9,1.6,2.6,3.2c-1.3,6.9-5.7,20.7-20.9,35.7c-0.6,0.6-1.5,1-2.4,0.9l-0.1,0c-6.2-0.2-9.8,6.6-6.7,11.5 C119.6,58.7,120.9,59,121.9,58.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M147.1,5.6c0,0.3,0.1,0.7,0.2,1c-0.3-0.1-0.6-0.2-0.9-0.2c-1.3,0-2.5,0.9-2.7,2.3l0,0.2 c-0.8,4.2-4.6,7.4-8.9,7.2l-2.5-0.1c-1.2,0-2.1-1-2.1-2.2c0-1.2,1-2.1,2.2-2.1l2.5,0.1c2.2,0.1,4.2-1.5,4.6-3.7l0-0.2 c0.6-3.4,3.6-5.9,7.1-5.8c1.1,0,2.2,0.3,3.1,0.8C148.2,3,147.1,4.2,147.1,5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M155.7,54c-4.5-3.5-13.4-8.7-20.9-1.3c-10.4,10.4-16.9,23-7.9,28.2c5.5,3.2,6.9,9.2,7.2,13.4 c13-8.6,21.6-23.3,21.6-40.1C155.7,54.3,155.7,54.1,155.7,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M80.5,52.8c-7.5-7.5-16.4-2.3-20.9,1.3c0,0.1,0,0.2,0,0.3c0,16.7,8.6,31.5,21.6,40.1 c0.3-4.2,1.7-10.2,7.2-13.4C97.4,75.7,90.9,63.1,80.5,52.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecognition);
export default __webpack_public_path__ + "static/media/recognition.4b1db917b7f66d9b5e7de58826153d12.svg";
export { ForwardRef as ReactComponent };